import { ArrowLeftIcon } from '@/components/ui/icons'
import type { Subgeo } from '@/features/subgeo/types'
import { useTranslation } from '@/translations/i18n'
import { NeighborhoodActions } from './neighborhood-actions'

interface NeighborhoodDetailProps {
	neighborhoodId: string
	neighborhoodName: string
	currentSubgeo: Subgeo | null
	subgeos: Subgeo[]
	onBack: () => void
}

export const NeighborhoodDetail = ({
	neighborhoodId,
	neighborhoodName,
	currentSubgeo,
	subgeos,
	onBack
}: NeighborhoodDetailProps) => {
	const { t } = useTranslation()

	return (
		<div className='flex h-full w-full flex-col gap-2 overflow-y-auto bg-neutral-white p-2.5'>
			<div className='flex w-full flex-col gap-2'>
				<button
					className='flex cursor-pointer items-center gap-1 border-none bg-transparent p-0 font-medium text-blue-600 text-sm transition-colors hover:text-blue-700'
					onClick={onBack}
					type='button'
				>
					<ArrowLeftIcon size={16} />
					{t('common:back')}
				</button>
				<div className='flex flex-col items-start gap-0.5'>
					<h3 className='m-0 font-semibold text-lg text-neutral-900'>
						{neighborhoodName}
					</h3>
					<small className='text-neutral-500 text-xs'>
						{currentSubgeo
							? t('subgeo:ngbhds_part_of_subgeo', {
									name: currentSubgeo.name
								})
							: t('subgeo:unassigned')}
					</small>
				</div>
			</div>

			<NeighborhoodActions
				currentSubgeo={currentSubgeo}
				neighborhoodId={neighborhoodId}
				showActionButtons={true}
				subgeos={subgeos}
			/>
		</div>
	)
}
